import { render, staticRenderFns } from "./RegisterCoproducerStep01.vue?vue&type=template&id=7e90c188&scoped=true&"
import script from "./RegisterCoproducerStep01.vue?vue&type=script&lang=js&"
export * from "./RegisterCoproducerStep01.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCoproducerStep01.vue?vue&type=style&index=0&id=7e90c188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e90c188",
  null
  
)

export default component.exports